import React from 'react';
import {Box, Heading, Stack, Alert, AlertIcon, Link, VStack, Grid, Image, Text, Flex, IconButton} from '@chakra-ui/react';
import {Link as RouterLink} from 'react-router-dom';
import GaiLogo from '../images/logo_300x129_transparent.png';
import {IoRefresh} from 'react-icons/io5';
import {useQuery} from 'react-query';
import {get} from '../service/ApiService';
import {ServiceStatus} from '../service/Urls';
import ErrorHelper from '../service/ErrorHelper';
import {isClientPersonnelOnly} from '../helpers/localStorage';

const Home = () => {
  const [lastUpdated, setLastUpdated] = React.useState(new Date());
  const [toast, setToast] = React.useState(null);

  const {data, isFetching} = useQuery(['service-status', lastUpdated], () => get(ServiceStatus.LIST), {
    onSuccess: response => {
      const {isSuccess, error} = response;

      if (!isSuccess) {
        setToast({response: {error: true}, errorMessage: error});
      }
    },
    keepPreviousData: true,
  });

  const services = data?.data ?? [];

  return (
    <Box textAlign="center" fontSize="xl">
      <Grid minH="100vh" p={3}>
        <VStack spacing={8}>
          <Image mx={'30'} my="3" src={GaiLogo} maxW={{base: 'lg', md: 'sm'}} />

          {isClientPersonnelOnly() ? null : (
            <Stack spacing={3} width={600}>
              <Flex justify="space-between" alignItems="flex-end">
                <Text textAlign="left" fontSize="medium">
                  Last Updated: {lastUpdated.toLocaleString()}
                </Text>

                <IconButton
                  onClick={() => setLastUpdated(new Date())}
                  colorScheme="blackAlpha"
                  size="sm"
                  icon={<IoRefresh fontSize="20px" />}
                  disabled={isFetching}
                  aria-label="Refresh"
                />
              </Flex>

              {services.map(service => (
                <Alert key={service.serviceName} height="40px" fontSize="medium" status={service.isAliveAndWell ? 'success' : 'error'}>
                  <AlertIcon boxSize="20px" />
                  {service.serviceName}
                  <Text fontSize="smaller" color="gray.600" ml={1.5}>
                    Last Ping: {service.lastRan ? new Date(service.lastRan).toLocaleString() : 'Never'}
                  </Text>
                  <b style={{flex: 1, textAlign: 'right'}}>{service.isAliveAndWell ? 'Healthy' : 'Down'}</b>
                </Alert>
              ))}
            </Stack>
          )}

          <Box flex="1" alignContent={'center'} alignSelf="center">
            <Heading size="xl" mb="3">
              Survey Management System
            </Heading>

            <Heading size="xl">Funeral Service Research Group®</Heading>
          </Box>

          <Link as={RouterLink} color="teal.500" fontSize="2xl" to={'/reports'}>
            {' '}
            View Reports{' '}
          </Link>
        </VStack>
      </Grid>

      <ErrorHelper toastResponse={toast} />
    </Box>
  );
};

export default Home;
